module.exports = __webpack_public_path__ + "img/content1_banner.2759875e.jpg";